import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';

import { cn } from '../../utils/cn';

export const RadioGroup = forwardRef(function RadioGroup(
  { className, ...props },
  ref,
) {
  return (
    <RadixRadioGroup.Root
      ref={ref}
      className={cn('flex flex-col space-y-space-3', className)}
      {...props}
    />
  );
});

export const RadioGroupItem = forwardRef(function RadioGroupItem(
  { className, ...props },
  ref,
) {
  return (
    <RadixRadioGroup.Item
      ref={ref}
      data-ds-id={props.checked ? 'ds/input/radio--selected' : 'ds/input/radio--default'}
      className={cn(
        'aspect-square size-space-5 rounded-ds-full border border-stone-300 dark:border-stone-600 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-4 data-[state=checked]:border-sage-500 data-[state=checked]:shadow-[0_4px_12px] data-[state=checked]:shadow-sage-glow',
        className,
      )}
      {...props}
    >
      <RadixRadioGroup.Indicator className="flex h-full w-full items-center justify-center" />
    </RadixRadioGroup.Item>
  );
});

/**
 * Convenience: row with a radio + visible label, looking like a tappable card.
 * Used by onboarding forms (employment_type, has_dependents, ...).
 */
export function RadioCard({ value, id, label, description, disabled = false, className }) {
  return (
    <label
      htmlFor={id}
      data-ds-id="ds/form/choice-card--default"
      className={cn(
        'group flex cursor-pointer items-start gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 text-left shadow-sm transition hover:border-sage-300 dark:hover:border-sage-700 has-[:checked]:border-sage-500 has-[:checked]:bg-sage-tint dark:has-[:checked]:border-sage-600 dark:has-[:checked]:bg-sage-900/50',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
    >
      <RadioGroupItem value={value} id={id} disabled={disabled} className="mt-1" />
      <span className="flex flex-col">
        <span className="font-medium text-foreground">{label}</span>
        {description ? (
          <span className="text-type-body-sm text-muted-foreground">{description}</span>
        ) : null}
      </span>
    </label>
  );
}
